<script lang="ts" setup>
import { OptionProps } from "~/components/Filters/Utils/Option.props"

const props = withDefaults(defineProps<OptionProps>(), {
  type: "check",
  nResults: 0
})

const emit =
  defineEmits<{
    (e: "clicked"): void
  }>()
const isCheck = computed(() => props.type === "check")
</script>

<template>
  <div
    class="option flex items-center gap-x-1 py-1"
    :class="{
      'justify-between': !isCheck,
      'pointer-events-none cursor-default select-none grayscale': disabled
    }"
  >
    <div v-if="isCheck" class="p-2">
      <ControlsCheckbox
        :model-value="checked"
        @clicked="() => emit('clicked')"
        :id="name"
        :name="name"
      />
    </div>
    <label
      v-if="!!text"
      class="beaver cursor-pointer whitespace-normal"
      :for="name"
    >
      {{ text }} <span class="text-black-40">({{ nResults }})</span>
    </label>
    <ControlsToggle
      v-if="!isCheck"
      :model-value="checked"
      @clicked="() => emit('clicked')"
      :id="name"
      :name="name"
    />
  </div>
</template>
